import axios from "axios";

export function saveCustomerDocuments(transactionId: string) {
    const url = `${process.env.REACT_APP_SAVE_DOCUMENTS_URL}/start`;
    const data = {
        transactionId,
        brand: process.env.REACT_APP_BRAND
    };

    return axios.post(url, data);
}

export function saveCustomerDocumentsStatus(transactionId: string) {
    return axios.get(
        `${process.env.REACT_APP_SAVE_DOCUMENTS_URL}/${transactionId}/status`
    );
}